import React, {useEffect, useState} from 'react'
import './style.scss'
import {useModal} from "react-modal-hook";
import PanModal from "../core/PanModal";
import SearchInn from "./searchInn";
import Button from "../core/Button";
import Dropdown from "../Dropdown";
import useApi from "../../hooks/useApi";
import Preloader from "../Preloader";
import request from "../../api";
import { infoToast, standartErrorToast, successToast, warningToast } from "../toasts";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';
import useDebounceState from "../../hooks/useDebounceState";

const StartModal = () => {

  const {confirmationRequests, agentCompany} = useSelector(state=>state.user?.info || {}, shallowEqual)

  const closeForSomeTime = () => { // 24*60*60*1000 - на сутки, 300*1000 - на 5 минут
    const timeout = 300*1000
    localStorage.setItem( "companyModalTimer", new Date(Date.now() + timeout).getTime() )
    infoToast(<>В случае возникновения сложностей, пожалуйста, свяжитесь с отделом развития.<br/> Без указания/создания компании полноценная работа невозможна.</>)
    closeStartModal({ autoClose: 8000 })
  }

  const [openStartModal, closeStartModal] = useModal(
    () => (
      <PanModal customClass="start-modal" isSmall title={'Получите полный доступ к сайту'} closeModal={closeForSomeTime} hashParams={false}>
        <StartModalContent closeStartModal={closeForSomeTime}/>
      </PanModal>
    ),
    [closeForSomeTime])

  useEffect(() => {

    const timeout = localStorage.getItem("companyModalTimer")

    const timeoutCondition = timeout && ((Date.now() - timeout) < 0)

    if(confirmationRequests || agentCompany || timeoutCondition) return

    openStartModal()
  }, [])

  return (
    <>

    </>
  )
}

export default StartModal

const StartModalContent = ({closeStartModal}) => {

  const [modalView, setModalView] = useState('first')
  const [post, setPost] = useState(1);
  const [postPost, setPostPost] = useState('agent');
  const [selectedCopmany, setSelectedCompany] = useState(null)
  const [selectedInn, setSelectedInn] = useState(null)
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const dispatch = useDispatch()

  const history = useHistory()

  const goToCompanyCreate = () => {
    closeStartModal()
    history.push(`/personalcabinet/company?create=true`)
  }
  const posts = [
    {
      id: 1,
      title: 'Агент',
      post: 'agent'
    },
    {
      id: 2,
      title: 'Руководитель',
      post: 'director'
    },
  ];

  const postValue = () => posts.find((item) => item.id === post);

  const {data: {companies}, isLoading} = useApi({
    payload: ["panpartner:company.ajax", "companyList",]
  }, [])


  const handlePostChange = (selectedPost ) => {
    setPost(selectedPost.id);
    setPostPost(selectedPost.post);
  };

  const сallbackRegistration = () => {
    return request("panpartner:company.ajax", "сallbackRegistration", )
      .then(
        data => {
          closeStartModal()
          successToast(data.message)
        }
      )
  }

  const addConfirmation = (type, companyId) => {
    return request("panpartner:company.ajax", "addConfirmation", {type, companyId})
      .then(
        data => {
          if(type === 'agent') {
            closeStartModal()
            successToast(data.message)

          }
          if(type === 'director') {
            setModalView('last')
            successToast(data.message)
          }

          dispatch({ type: "USER_EDIT", data: { confirmationRequests: true } })

        })
  }

  if (isLoading) return <Preloader loading />;
  return (
    <>
      {modalView === 'first' &&
      <div className="start-modal-content">
        <p style={{marginBottom: 30}}> Введите название компании, ИНН или фамилию ИП,<br/> где вы работаете</p>
        <SearchInn
          companies={companies}
          setModalView={setModalView}
          setSelectedCompany={setSelectedCompany}
          setSelectedInn={setSelectedInn}
          selectedCopmany={selectedCopmany}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchResults={searchResults}
          setSearchResults={setSearchResults}
        />
        <div className="start-modal-content__btn">
          <Button isFull buttonType="secondary" onClick={goToCompanyCreate} type="button">Зарегистрировать новое агентство</Button>
        </div>
      </div>
      }
      {modalView === 'second' &&
        <div className="start-modal-content">
          <p style={{marginBottom: 30}}>Выберите вашу роль в компании</p>
          <div className="start-modal-content__block">
            <SearchInn
              companies={companies}
              setModalView={setModalView}
              setSelectedCompany={setSelectedCompany}
              setSelectedInn={setSelectedInn}
              selectedCopmany={selectedCopmany}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              searchResults={searchResults}
              setSearchResults={setSearchResults}
            />
            <div className="cabinet-input">
              <input
                type="text"
                disabled={true}
                value={`ИНН ${selectedInn}`}
              />
            </div>
            <div className="cabinet-input">
              <Dropdown
                value={postValue()}
                options={posts}
                onChange={(value) => {
                  const selectedPost = posts.find((p) => p.id === value);
                  handlePostChange(selectedPost);
                }}/>
            </div>
          </div>
          <div className="start-modal-content__btn start-modal-content__btn_second">
            <Button isFull buttonType="primary" onClick={() => addConfirmation(postPost, selectedInn)} type="button">Сохранить</Button>
            <Button isFull buttonType="secondary" onClick={goToCompanyCreate} type="button">Зарегистрировать новое агентство</Button>
          </div>
        </div>
      }

      {modalView === 'last' &&
        <div className="start-modal-content">
          <p className="start-modal-content__text">
            Если вы хотите <b>восстановить доступ</b> к своей компании, оставьте заявку, и мы перезвоним вам в течение 30 минут или свяжитесь с сотрудниками отдела развития по номеру <b>+7 (812) 426-18-63</b>
          </p>
          <div className="start-modal-content__btn start-modal-content__btn_second">
            <Button isFull buttonType="primary" onClick={сallbackRegistration} type="button">Прошу перезвонить</Button>
          </div>
        </div>
      }
    </>
  )
}
